module.exports = "data:image/gif;base64,R0lGODlhEwAUALMIAMbV4a3D1KzC1LzO3LbJ2eDo7v///6zC01mFqAAAAAAAAAAAAAAAAAAAAAAAAAAAACH5BAEAAAgALAAAAAATABQAAARUEMlJq62ABAJuHUcoHoOHCGMqXGiqfmnhkpRryG6dGrfbIQQbDyciSALC4SggCe54vaIEkCSGdCNligLKWkMlSiv0PawsY9f50k2FTYjM5gev2+ERADs="


//////////////////
// WEBPACK FOOTER
// ./src/assets/rightArrow.gif
// module id = pSrk
// module chunks = 0